import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { EMPTY, Subject, Subscription, of } from 'rxjs';
import { finalize, switchMap, tap } from 'rxjs/operators';
import { SeveritySelected } from 'src/app/helpers';
import { AuthService } from 'src/app/services/auth/auth.service';
import { EstimatesService } from 'src/app/services/estimates/estimates.service';
import { RatingService } from 'src/app/services/rating/rating.service';
import { SharedService } from 'src/app/services/shared/shared.service';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss'],
})
export class ConfirmModalComponent implements OnInit {
  public apiError: boolean = false;
  public saving: boolean = false;
  public role: string = 'admin';

  public vinInfo: Object = {};
  public selectedSeverity: SeveritySelected = {
    exterior: {
      state: [],
      overall: {
        rating: null,
        labour_cost: null,
        part_cost: null,
        repair_cost: null,
      },
      endCorrection: {},
    },
    interior: {
      state: [],
      overall: {
        rating: null,
        labour_cost: null,
        part_cost: null,
        repair_cost: null,
      },
      endCorrection: {},
    },
    mechanics: {
      state: [],
      overall: {
        rating: null,
        labour_cost: null,
        part_cost: null,
        repair_cost: null,
      },
      endCorrection: {},
    },
    frame: {
      state: [],
      overall: {
        rating: null,
        labour_cost: null,
        part_cost: null,
        repair_cost: null,
      },
      endCorrection: {},
    },
    major_options: {
      state: [],
      overall: {
        rating: null,
        labour_cost: null,
        part_cost: null,
        repair_cost: null,
      },
      endCorrection: {},
    },
  };
  public overAllObj: Object = {};
  public extOverall: number = null;
  public intOverall: number = null;
  public frameOverall: number = null;
  public mecOverall: number = null;
  public majorOptOverall: number = null;

  public extOverallCost: number = null;
  public intOverallCost: number = null;
  public frameOverallCost: number = null;
  public mecOverallCost: number = null;
  public majorOptOverallCost: number = null;
  public gradeCV: number | string = null;
  public gradePV: number | string = null;

  public saved: Subject<boolean>;

  public subscriptions: Subscription[] = [];

  constructor(
    public modal: BsModalRef,
    public authService: AuthService,
    public ratingService: RatingService,
    public estimateService: EstimatesService,
    public sharedService: SharedService,
    public toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.getUserData();
    this.getVinInfo();
    this.getState();
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });
  }

  getVinInfo() {
    const infoSub = this.sharedService.vinInformation.subscribe((res) => {
      if (res) {
        this.vinInfo = res;
      }
    });
    this.subscriptions.push(infoSub);
  }

  getUserData() {
    const userDataSub = this.authService.user.subscribe((res) => {
      const user = res?.user ? res.user : null;
      this.role = user?.user_data?.role || 'admin';
    });
    this.subscriptions.push(userDataSub);
  }

  overAllCheck: boolean = false;
  getState() {
    let data: object = { vehicle_id: this.sharedService.getVehicleId };

    const stateSub = this.ratingService.getRatingStates(data).subscribe(
      (res) => {
        if (res) {
          let success: boolean = res['success'];
          let data: object = res['data'];

          if (success && Object.keys(data).length) {
            const states: SeveritySelected = data['ratingStates']
              ? JSON.parse(data['ratingStates']['rating_states'])
              : null;
            // let interiorEC: object = states ? states.interior.endCorrection : {};
            // let frameEC: object = states ? states.frame.endCorrection : {};

            this.selectedSeverity = states;
            
            this.overAllObj = res;
            this.overAllCheck =
              this.overAllObj &&
              Object.keys(this.overAllObj).length &&
              typeof this.overAllObj === 'object';
            this.ratingService.overallChecker.next(this.overAllCheck);

            if (this.overAllCheck) {
              this.extOverall = +(states
                ? states['exterior']['overall']['rating'] ?? 5
                : 5);
              this.intOverall = +(states
                ? states['interior']['overall']['rating'] ?? 5
                : 5);
              this.mecOverall = +(states
                ? states['mechanics']['overall']['rating'] ?? 5
                : 5);
              this.frameOverall = +(states
                ? states['frame']['overall']['rating'] ?? 5
                : 5);
              this.majorOptOverall = +(states
                ? states['major_options']['overall']['rating'] ?? 5
                : 5);

              this.extOverallCost = +(states
                ? states['exterior']['overall']['repair_cost'] ?? 0
                : 0);
              this.intOverallCost = +(states
                ? states['interior']['overall']['repair_cost'] ?? 0
                : 0);
              this.mecOverallCost = +(states
                ? states['mechanics']['overall']['repair_cost'] ?? 0
                : 0);
              this.frameOverallCost = +(states
                ? states['frame']['overall']['repair_cost'] ?? 0
                : 0);
              this.majorOptOverallCost = +(states
                ? states['major_options']['overall']['repair_cost'] ?? 0
                : 0);

              //   this.extOverall,
              //   this.intOverall,
              //   this.mecOverall,
              //   this.frameOverall,
              //   this.majorOptOverall,
              // );

              this.gradeCV =
                this.extOverall * 0.5 +
                this.intOverall * 0.1 +
                this.mecOverall * 0.3 +
                this.frameOverall * 0.05 +
                this.majorOptOverall * 0.05;

              this.endCorrection(this.gradeCV);
            }
          }
          else {
            this.apiError = true;
          }
        }
      },
      (error: HttpErrorResponse) => {
        this.apiError = true;
      }
    );

    this.subscriptions.push(stateSub);
  }

  endCorrection(grade: number) {
    this.gradePV = null;

    let milage: object =
      this.vinInfo && this.vinInfo['odo'] ? this.vinInfo['odo'] : null;

    if (grade >= 4 && milage['value'] > 100000) {
      this.gradePV = 3.9;
    }

    if (this.selectedSeverity) {
      let interior: Object = this.selectedSeverity.interior.endCorrection;
      let frame: Object = this.selectedSeverity.frame.endCorrection;
      let mechanics: Object = this.selectedSeverity.mechanics.endCorrection;

      if (Object.keys(interior).length && interior) {
        let airBagSeverityLvl: number | string =
          interior['air_bag'].severity_level;

        if (grade >= 3.4) {
          if (+airBagSeverityLvl === 1) {
            this.gradePV = 3.4;
          }
        }
      }

      if (Object.keys(mechanics).length && mechanics) {
        for (let prop in mechanics) {
          if (grade >= 4) {
            let severityLvl: number | string = mechanics[prop].severity_level;

            if (+severityLvl < 3) {
              this.gradePV = 3.9;
            }
          }
        }
      }

      if (Object.keys(frame).length && frame) {
        for (let prop in frame) {
          if (grade >= 2.4) {
            let severityLvl: number | string = frame[prop].severity_level;

            if (+severityLvl < 3) {
              this.gradePV = 2.4;
            }
          }
        }
      }
    }

    this.gradePV = +(+this.gradePV).toFixed(1);
  }

  saveData() {
    if (this.overAllCheck) {
      let repairCostTotal: number =
        this.extOverallCost +
        this.intOverallCost +
        this.mecOverallCost +
        this.frameOverallCost +
        this.majorOptOverallCost;

      const ratingOverall: Object = {
        vehicle_id: this.sharedService.getVehicleId,
        overall_exterior: this.extOverall.toString(),
        overall_interior: this.intOverall.toString(),
        overall_mechanics: this.mecOverall.toString(),
        overall_frame: this.frameOverall.toString(),
        overall_major_options: this.majorOptOverall.toString(),
        calculated_value: this.gradeCV.toString(),
        perceived_value: (this.gradePV || 0).toString(),
        overall_repair_cost: repairCostTotal.toString(),
      };

      this.saving = true;
      this.ratingService
        .setRatingOverall(ratingOverall)
        .pipe(
          switchMap((res) => {
            let success: boolean = res['success'];
            let data: any = res['data'];

            if (!success) {
              this.toastr.error(data, 'Failed');
              return EMPTY;
            }

            return this.role === 'evaluator'
              ? this.estimateService.updateRevamCount({
                  vehicle_id: this.sharedService.getVehicleId
                })
              : of(null);
          }),
          tap(() => {
            this.ratingService.ratingSaved.next(true);
            this.saved.next(true);
            this.saved.complete();
            this.modal.hide();
            this.toastr.success('Ratings submitted successfully', 'Success');
          }),
          finalize(() => {
            this.saving = false;
          })
        )
        .subscribe({
          error: () => {
            this.toastr.error('Something went wrong', 'Failed');
          }
        });
    } else {
      this.ratingService.ratingSaved.next(true);
      this.saved.next(true);
      this.saved.complete();
      this.modal.hide();
    }
  }
}
